var formAction = "https://landingreceiver.youandemili.com/api/v1/landing/process/json";
var gdprFormDescriptor = "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";

var genericError = "Siamo spiacenti ma si è verificato un errore. La invitiamo a riprovare più tardi";
var userExistError = "Indirizzo email già registrato. Provare con un indirizzo diverso.";
var successTitle = "New Holland ti ringrazia per il tuo interessamento.";
var successMessage = "Verrai ricontattato al più presto.";
var errorMessage = "Campo obbligatorio.";
var errorMessageEmail = "Inserire un indirizzo email valido.";
var errorMessagePhone = "Inserire un numero di telefono che contenga il prefisso internazionale (esempio: +39xxxxxxxxx)";
var errorCityNumbers = "I numeri non sono ammessi";


$(document).ready(function () {

  jQuery.validator.addMethod("notNumber", function (value, element, param) {
    var reg = /[0-9]/;
    if (reg.test(value)) {
      return false;
    } else {
      return true;
    }
  }, errorCityNumbers);

  $("#phonenumber").keypress(function (e) {
    if (String.fromCharCode(e.which).match(/[^+0-9]/)) {
      e.preventDefault();
    }
  });

  $("#city").keypress(function (e) {
    e = e || window.event;
    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
    if (/\d/.test(charStr)) {
      e.preventDefault();
    }
  });

  $("#purchaseintention").on("change", function () {
    setPurchaseIntentionText();
  });

  $("#contactreason").on("change", function () {
    contactReasonSelectChange();
  });

  setScrollBehavior();
  setCarouselItemHeight();

  $(".ae-btn-submit").attr("disabled", "disabled");

  GetFormDescriptor();
  setFormValidation();

  configLandigReceiver();

  var $copy = $(".ae-copyright").html();
  $(".ae-copyright").html($copy.replace("{year}", new Date().getFullYear()));

});


$(window).on("resize", function () {
  var $m = $("main");
  var bg = $m.attr('data-bg');
  if ($m.hasClass("lazyloaded")) {
    if ($(window).width() <= 991) {
      bg = $m.attr('data-bg-mobile');
    }

    var current = $m.css("background-image");
    if (current.indexOf(bg) === -1) {

      $m.css({
        "background-image": 'url(' + bg + ')'
      });

    }
  }

  setCarouselItemHeight();
});

$(document).on('lazyloaded', function (e) {
  var $target = $(e.target);
  var $parent = $target.parent();
  if ($parent.hasClass("ae-img-spinner")) {
    $parent.addClass("ae-loaded");
  }
  if ($target.hasClass("ae-img-spinner")) {
    $target.addClass("ae-loaded");
  }
});

$(window).on("load", function () {
  $(".ae-img-spinner:not(.ae-loaded) .lazyloaded").each(function () {
    $(this).parent().addClass("ae-loaded");
    $(this).addClass("ae-loaded");
  });
});

/***** FUNCTIONS  *****/


function switchLazyBg(item) {
  var $h = $(item);
  var bg = $h.attr('data-bg');
  if ($h.hasClass("lazyloaded")) {
    if ($(window).width() <= 576) {
      bg = $h.attr('data-bg-mobile');
    }

    var current = $h.css("background-image");
    if (current.indexOf(bg) === -1) {

      $h.css({
        "background-image": 'url(' + bg + ')'
      });

    }
  }
}


function setPurchaseIntentionText() {
  $("#purchaseintentionText").val($("#purchaseintention option:selected").text());
}

function contactReasonSelectChange() {
  $("#contactreasonText").val($("#contactreason option:selected").text());
  if ($("#contactreason option:selected").val() === "4" ) {
    $("#contactreasonother").removeClass("d-none");
  } else {
    $("#contactreasonother").addClass("d-none");
    $("#contactreasonother").val("");
  }
}

function setFormValidation() {
  //form validate 
  $("#landing-form").validate({
    errorElement: "span",
    rules: {
      city: 'notNumber'
    },
    preferredContact: {
      required: true
    },
    messages: {
      firstname: errorMessage,
      lastname: errorMessage,
      phonenumber: errorMessage,
      postalcode: errorMessage,
      city: {
        required: errorMessage,
        notNumber: errorCityNumbers
      },
      businessname: errorMessage,
      province: errorMessage,
      purchaseintention: errorMessage,
      contactreason: errorMessage,
      contactreasonother: errorMessage,
      email: {
        required: errorMessage,
        email: errorMessageEmail
      },
      gdpr_0: errorMessage,
      gdpr_1: errorMessage,
      gdpr_2: errorMessage,
    }
  });
}


function configLandigReceiver() {
  //campaign tracking
  var gtmref = getUrlParameter("utm_source");
  var gtmcampaign = getUrlParameter("utm_campaign");
  var gtmmedium = getUrlParameter("utm_medium");
  var gtmcontent = getUrlParameter("utm_content");
  var placement = getUrlParameter("placement");
  var adset = getUrlParameter("adset");
  var campaignname = getUrlParameter("campaign_name");

  if (gtmref != undefined) {
    $("#gtmref").val(gtmref);
  }
  if (gtmcampaign != undefined) {
    $("#gtmcampaign").val(gtmcampaign);
  }

  if (gtmmedium != undefined) {
    $("#gtmmedium").val(gtmmedium);
  }

  if (gtmcontent != undefined) {
    $("#gtmcontent").val(gtmcontent);
  }

  if (placement != undefined) {
    $("#placement").val(placement);
  }

  if (adset != undefined) {
    $("#adset").val(adset);
  }

  if (campaignname != undefined) {
    $("#campaignname").val(campaignname);
  }

  //final form post
  $("#landing-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var form = $("#landing-form");

    var gdprMarketing = $("input[name=gdpr_1]:checked").val();
    var gdprMarketingThird = $("input[name=gdpr_2]:checked").val();
    console.log("gdprMarketing", gdprMarketing);
    console.log("gdprMarketingThird", gdprMarketingThird);
    if (gdprMarketing === "1" || gdprMarketingThird === "1") {
      $("#contact_email").val("1");
      $("#contact_phone").val("1");
      $("#contact_sms").val("1");
    } else {
      $("#contact_email").val("0");
      $("#contact_phone").val("0");
      $("#contact_sms").val("0");
    }


    if (form.valid()) {
      $(".ae-btn-submit").attr("disabled", "disabled");
      $("#waiting-form").removeClass("d-none");

      postData(form);
    }
    return false;
  });
}

function postData(form) {
  var formData = form.serializeArray();

  var jsonData = {
    "url": window.location.href,
    "name": $("#landingName").val(),
    "id": $("#lid").val(),
    "data": objectifyForm(formData)
  };

  //console.log(jsonData);

  //post
  $.ajax({
    async: true,
    type: "POST",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: formAction,
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(jsonData),
    success: function (resp) {
      //console.log(resp);
      var obj = JSON.parse(JSON.stringify(resp));
      if (obj.status === 1) {
        try {

          //Tracciamento del form inviato
          /**** GTM Navigation Event ****/
          if (typeof dataLayer !== "undefined") {

            dataLayer.push({
              "event": "Pageview",
              "pagePath": location.pathname.replace("index.html", "") + "/form-send/",
              "pageTitle": "Forn send | " + $(document).find("title").text()
            });
          }

          showSuccess()
          document.getElementById("landing-form").reset();
        } catch (err) {
          console.log(err)
          showError(genericError);
        }

        $(".ae-btn-submit").removeAttr("disabled");
        $("#waiting-form").addClass("d-none");

      } else {

      }
    },
    error: function (err) {
      var obj = JSON.parse(JSON.stringify(err));
      //console.log("ERR");
      //console.log(obj);
      if (obj.status === 400) {
        var objResp = JSON.parse(JSON.stringify(obj.responseJSON));
        console.log(obj.responseJSON);
        if (objResp.status === 3) {
          //console.log(objResp.validationErrors);
          $.each(objResp.validationErrors, function (k, er) {
            if (er["fieldName"] == "phonenumber") {
              //em = em + errorMessagePhone + "<br />";
              $("#phonenumber").addClass("error");
              $('<span id="phonenumber-not-valid-error" class="error">' + errorMessagePhone + '</span>').insertAfter("#phonenumber");
            }
            if (er["fieldName"] == "email") {
              showError(errorMessageEmail);
            }
          });
        } else if (objResp.status === 4) {
          //email esistente
          showError(userExistError);
        } else {
          showError(genericError);
        }
      }
      $(".ae-btn-submit").removeAttr("disabled");
      $("#waiting-form").addClass("d-none");
    }
  });

}



function getUrlParameter(sParam) {

  var sPageURL = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

//create json from form data
function objectifyForm(formArray) {

  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]['name']] = formArray[i]['value'];
  }
  return returnArray;
}

function showError(err) {
  bootbox.alert({
    centerVertical: true,
    message: '<h5 class="text-danger text-uppercase"></h5><div class="text-danger">' + err + '</div>'
  });
}

function showSuccess() {
  bootbox.alert({
      centerVertical: true,
      message: '<div id="form-success"><h5 class="text-uppercase ae-lid-form-success">' + successTitle + '</h5><div>' + successMessage + '</div></div>',
    }

  );
}


/**** GDPR ****/

function GetFormDescriptor() {
  $.ajax({
    async: true,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: gdprFormDescriptor,
    success: function (resp) {
      if (resp != null) {
        $("#gdpr").val(JSON.stringify(resp));
        GenerateFields(resp);
        $(".ae-btn-submit").removeAttr("disabled");
        // setInfoSectionPosition();
      }
    },
    error: function (resp) {
      //console.log(resp)

    }

  });
}

function GenerateFields(x) {
  $.each(x, function (key, val) {
    if (key === "policies") {
      $.each(val, function (index, value) {
        if (value.type === "checkbox") {
          GenerateChecbox(value)
        }

        if (value.type === "radio") {
          GenerateRadio(value)
        }

      });
    }
  });
}

function GenerateChecbox(policy) {
  var html =
    '<div class="form-group custom-control custom-checkbox">' +
    '<input type="checkbox" class="custom-control-input gdpr-checkbox" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" ' + (policy.required ? "required" : "") + ' />' +
    '<label class="gdpr-policy-label custom-control-label" for="gdpr_' + policy.id + '">' + policy.description + ' *</label>' +
    '</div>' +
    '</div>';

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);

}

function GenerateRadio(policy) {
  var html = ' <div class="form-group"> ' +
    '<div><div class="gdpr-scrollable">' +
    policy.title + " *<br />" + policy.description +
    '<br />' +
    '</div>' +
    '<div class="custom-control custom-radio custom-control-inline">' +
    '<input class="custom-control-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-0" value="1" required />' +
    '<label class="custom-control-label" for="gdpr_' + policy.id + '-0">' + policy.accept_label + '</label>' +
    '</div>' +
    '<div class="custom-control custom-radio custom-control-inline">' +
    '<input class="custom-control-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-1" value="0" /> ' +
    '<label class="custom-control-label" for="gdpr_' + policy.id + '-1">' + policy.deny_label + '</label>' +
    '</div>' +
    '</div></div>'

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}

function setScrollBehavior() {


  $('.scroll-link').click(function (e) {
    e.preventDefault();
    var offset = -100;
    if ($(window).width() <= 991.98) {
      offset = -74;
    }

    $(window).stop(true).scrollTo(this.hash, {
      duration: 1500,
      offset: offset,
      easing: 'easeOutCirc'
    });
  });
}

function setCarouselItemHeight() {
  $(".carousel .carousel-item .ae-item-text-container").each(function () {
    $(this).css("min-height", "");
  });

  $(".carousel").each(function (i) {
    var $items = $(this).find(".carousel-item");
    var h = 0;
    $items.each(function (k) {
      $(this).css("display", "block");
      var itemHeight = Math.ceil($(this).find(".ae-item-text-container").outerHeight());
      $(this).css("display", "");
      //console.log("itemHeight "+k,itemHeight);
      if (itemHeight > h) h = itemHeight;
    });

    $items.each(function () {
      $(this).find(".ae-item-text-container").css("min-height", h + "px");
    });
  });
}

function inViewport($el) {
  var elH = $el.outerHeight(),
    H = $(window).height(),
    r = $el[0].getBoundingClientRect(),
    t = r.top,
    b = r.bottom;
  return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
}